import React, { Fragment, PureComponent } from 'react';

class Footer extends PureComponent {
    state = {
        page: '',
        footer_menu: '',
        is_demo_active: true,
        year: new Date().getFullYear(),
    }

    componentDidMount() {
    }

    render() {
        return (
            <Fragment>
                <footer className="site-footer">
                    <aside className="footer-widgets col-xs-12">
                        <div className="prestigelabs-footer">
                            <ul className="">
                                <li className="">© {this.state.year} ALAN</li>
                                <li className=""><a target="_blank" rel="noopener noreferrer" title="ALAN Privacy Policy Notice" href="https://usealan.com/privacy-policy/" className="nav-link">ALAN Privacy Policy Notice</a></li>
                                <li className=""><a target="_blank" rel="noopener noreferrer" title="ALAN Terms of Use" href="https://usealan.com/terms-of-use/" className="nav-link">ALAN Terms of Use</a></li>
                            </ul>
                        </div>

                    </aside>
                </footer>
            </Fragment>
        );
    }
}

export default Footer;